import React from 'react'
import ReactDOM from 'react-dom/client'
import PageAlert from './PageAlert'

window.React = React
window.ReactDOMAlert = ReactDOM
window.PageAlert = PageAlert
window.ReactDOMVideo = ReactDOM

